<item-full-modal
    modalTitle="{{ (editable.id ? l10nKeys.modalTitleEdit : l10nKeys.modalTitleNew) | vtranslate }}"
    [item]="editable"
    [form]="form"
    (onSubmit)="editable.submit()"
>
    <form
        clrForm
        [clrLayout]="verticalLayout"
        #form="ngForm"
    >
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleGeneral | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleGeneral | vtranslate }}</h3>
                 <avi-input-container>
                    <label
                        aviLabelWithTooltip
                        fieldName="name"
                        for="name"
                        objectType="{{ objectType }}"
                        required
                    >
                        {{ l10nKeys.nameInputLabel | vtranslate }}
                    </label>
                    <input
                        id="name"
                        name="name"
                        [(ngModel)]="editable.config.name"
                        clrInput
                        placeholder="{{ l10nKeys.nameInputLabel | vtranslate }}"
                        regexPattern="objName"
                        required
                    />
                </avi-input-container>
                <avi-textarea-container>
                    <label
                        aviLabelWithTooltip
                        fieldName="description"
                        objectType="{{ objectType }}"
                        for="description"
                    >
                        {{ l10nKeys.descriptionLabel | vtranslate }}
                    </label>
                    <textarea
                        clrTextarea
                        id="description"
                        name="description"
                        [(ngModel)]="editable.config.description"
                        placeholder="{{ l10nKeys.descriptionLabel | vtranslate }}"
                    ></textarea>
                </avi-textarea-container>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleDatabases | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleDatabases | vtranslate }}</h3>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectType  }}"
                            fieldName="ip_reputation_db_uuid"
                            for="ip-reputation-db-uuid"
                        >
                            {{ l10nKeys.ipReputationDbInputLabel | vtranslate }}
                        </label>
                        <avi-collection-dropdown
                            name="ip-reputation-db-uuid"
                            [(ngModel)]="editable.config.ip_reputation_db_ref"
                            [collection]="ipReputationDBCollection"
                            placeholder="{{ l10nKeys.ipReputationDbInputPlaceholder | vtranslate }}"
                            [disableCreate]="true"
                            [disableEdit]="true"
                        ></avi-collection-dropdown>
                    </div>
                </div>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectType }}"
                            fieldName="geo_db_uuid"
                            for="geo-db-uuid"
                        >
                            {{ l10nKeys.geoDbInputLabel | vtranslate }}
                        </label>
                        <avi-collection-dropdown
                            name="geo-db-uuid"
                            [(ngModel)]="editable.config.geo_db_ref"
                            [collection]="geoDbCollection"
                            placeholder="{{ l10nKeys.geoDbInputPlaceholder | vtranslate }}"
                        ></avi-collection-dropdown>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleRules | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleRules | vtranslate }}</h3>
                <div class="full-modal-config__form-control">
                    <network-security-policy-rules-grid
                        [rules]="editable.config.rules"
                        (onAddRule)="onAddNetworkSecurityRule()"
                        (onEditRule)="onEditNetworkSecurityRule($event)"
                        (onDeleteRule)="onDeleteNetworkSecurityRule($event)"
                        (onRowOrderChange)="handleNetworkSecurityRuleGridRowReorder($event)"
                    ></network-security-policy-rules-grid>
                </div>
            </div>
        </full-modal-tab-section>
        <full-modal-tab-section tabTitle="{{ l10nKeys.sectionTitleRbac | vtranslate }}">
            <div class="full-modal-config__section">
                <h3>{{ l10nKeys.sectionTitleRbac | vtranslate }}</h3>
                <div class="full-modal-config__form-control-row">
                    <div class="full-modal-config__form-control">
                        <role-filter-match-label
                            objectType="{{ objectType }}"
                            fieldName="markers"
                            [markers]="editable.config.markers"
                        ></role-filter-match-label>
                    </div>
                </div>
            </div>
        </full-modal-tab-section>
    </form>
</item-full-modal>
